import { createReducer, on } from '@ngrx/store';
import {
  IBillingAccount,
  IBillingBalance,
  IEMData,
} from '@dch/billing-business-logic';
import {
  getBillingBalanceFailure,
  getBillingBalanceRequest,
  getBillingBalanceSuccess,
  setSelectedBillingAccount,
} from '../actions/billing-balance.actions';

export interface BillingBalanceState {
  billingBalance: IEMData<IBillingBalance>;
  viewableBillingAccounts: Array<IBillingAccount>;
  selectedBillingAccount?: IBillingAccount;
  errorCode?: string;
}

export const initialState: BillingBalanceState = {
  billingBalance: { result: null, isFetching: false, hasError: false },
  viewableBillingAccounts: [],
  selectedBillingAccount: undefined,
  errorCode: undefined,
};

export const billingBalanceReducer = createReducer(
  initialState,
  on(getBillingBalanceRequest, (state) => ({
    ...state,
    billingBalance: {
      result: state.billingBalance.result,
      isFetching: true,
      hasError: false,
    },
    errorCode: undefined,
  })),
  on(getBillingBalanceSuccess, (state, { billingBalance }) => {
    const viewableBillingAccounts = billingBalance.billingAccounts;
    let selectedBillingAccount;
    if (
      state.selectedBillingAccount !== undefined &&
      viewableBillingAccounts.length > 1
    ) {
      selectedBillingAccount = viewableBillingAccounts.find(
        (account) =>
          account.accountNumber === state.selectedBillingAccount.accountNumber
      );
    } else if (viewableBillingAccounts.length === 1) {
      selectedBillingAccount = viewableBillingAccounts[0];
    }

    return {
      ...state,
      viewableBillingAccounts,
      billingBalance: {
        result: billingBalance,
        isFetching: false,
        hasError: false,
      },
      selectedBillingAccount,
      errorCode: undefined,
    };
  }),

  on(setSelectedBillingAccount, (state, { billingAccountNumber }) => {
    return {
      ...state,
      selectedBillingAccount: billingAccountNumber
        ? state.viewableBillingAccounts.find(
            (account) => account.accountNumber === billingAccountNumber
          )
        : undefined,
    };
  }),
  on(getBillingBalanceFailure, (state, { errorCode }) => ({
    ...state,
    viewableBillingAccounts: [],
    billingBalance: {
      result: null,
      isFetching: false,
      hasError: true,
    },
    errorCode,
    selectedBillingAccount: undefined,
  }))
);
